import { Link } from 'react-router-dom';

import config from '@/config';
import { NewspaperArticleReadTime } from '@/pages/newspaper/slider-types/components/NewspaperArticleMeta';
import { buildPublicContentPath } from '@/utils/contentRoutes';

import './styles/NewspaperUnique.css';

function buildArticleLink(article = {}) {
  return article._id ? buildPublicContentPath({ ...article, post_type: 'article' }, 'article') : '#';
}

export default function NewspaperUnique({
  articles = [],
}) {
  const curatedArticles = [...articles]
    .filter(article => {
      const author = (article?.creator_username || article?.creator_name || '').toLowerCase();
      return author === 'suarte';
    })
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

  const fallbackSorted = [...articles]
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

  const featuredArticle = (curatedArticles[0] || fallbackSorted[0]) ?? null;
  const coverImageId = featuredArticle?.coverImageId ?? null;
  const coverImage = coverImageId
    ? `${config.app.imageServiceDomain}/${coverImageId}/w=1600`
    : null;

  if (!featuredArticle) {
    return null;
  }

  const articleLink = buildArticleLink(featuredArticle);
  const cardClassName = coverImage
    ? 'newspaper-unique__card newspaper-unique__card--with-media'
    : 'newspaper-unique__card';

  return (
    <Link to={articleLink} className={cardClassName}>
      {coverImage && (
        <div className="newspaper-unique__media" aria-hidden="true">
          <img src={coverImage} alt="" loading="lazy" />
        </div>
      )}

      <div className="newspaper-unique__content">
        <h2 className="newspaper-unique__headline">
          {featuredArticle.title}
        </h2>

        {featuredArticle.description && (
          <p className="newspaper-unique__summary">
            {featuredArticle.description}
          </p>
        )}

        <div className="newspaper-unique__footer">
          <NewspaperArticleReadTime
            article={featuredArticle}
            className="newspaper-unique__read-time"
          />
        </div>
      </div>
    </Link>
  );
}
